import { apiSlice } from "../store/api/adminApi"

export type PushNotificationAudience =
  | 'allOrganizers'
  | 'activeOrganizers'
  | 'notActiveOrganizers'
  | 'allUsers'

export type PushNotificationKind = 'custom' | 'docsUpdated'

export type DocsUpdateNotificationText = {
    en: { title: string; description: string }
    he: { title: string; description: string }
}

export type SendPushNotificationOtpBody = {
    kind: PushNotificationKind
    audience?: PushNotificationAudience
    testPhone?: string
    testUserName?: string
    titleEn?: string
    titleHe?: string
    textEn?: string
    textHe?: string
}

export const notificationApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getDocsUpdateNotificationText: build.query<DocsUpdateNotificationText, void>({
            query: () => ({
                url: `/admin/notification/docs-updated-text`,
            }),
        }),
        sendPushNotificationOtp: build.mutation<any, SendPushNotificationOtpBody>({
            query: (body) => ({
                url: `/admin/notification/push/otp`,
                method: 'POST',
                body,
            }),
        }),
        sendTestPushNotification: build.mutation<{ isTest: boolean; userId?: number }, SendPushNotificationOtpBody>({
            query: (body) => ({
                url: `/admin/notification/push/test`,
                method: 'POST',
                body,
            }),
        }),
        confirmSendPushNotification: build.mutation<{ isTest: boolean; userId?: number }, { code: string }>({
            query: ({ code }) => ({
                url: `/admin/notification/push/send`,
                method: 'POST',
                body: { code },
            }),
        }),
    }),
})
